import React from "react";
import PPTBadgeList from "../../PPTBadgeList";

/**
 * BadgeListCellRenderer - AG Grid cell renderer for badge lists
 *
 * @param {Object} props - AG Grid cell renderer props
 * @param {Array|string} props.value - Array of items or single item to display as badges
 * @param {number} [props.maxItems] - Optional max items to show before truncating with "+n"
 * @returns {JSX.Element}
 */
const BadgeListCellRenderer = ({ value, maxItems }) => (
  <PPTBadgeList value={value} maxItems={maxItems} />
);

export default BadgeListCellRenderer;
